import { BaseService } from "./BaseService";
import {
  IBillingSettingsService,
  ICreateStripeConnectPayload,
  ICreateStripeConnectResponse,
  ICreateStripeConnectLoginLinkResponse,
  HotelPaymentMethodsResponse,
  IRefreshStripeConnectPayload,
  IUpdateHotelPaymentSettingsPayload,
  StripeAccountRequirementsState,
  UpdateHotelPaymentMethodPayload,
  UpdateHotelPaymentMethodResponse,
} from "./interfaces/IBillingSettingsService";

class BillingSettingsService
  extends BaseService
  implements IBillingSettingsService
{
  constructor() {
    super();
  }

  createStripeConnect(
    hotelId: string,
    payload: ICreateStripeConnectPayload,
  ): Promise<ICreateStripeConnectResponse> {
    return this.post<ICreateStripeConnectResponse>(
      `/hotels/${hotelId}/payments/connect`,
      payload,
    );
  }

  refreshStripeConnect(
    hotelId: string,
    payload: IRefreshStripeConnectPayload,
  ): Promise<ICreateStripeConnectResponse> {
    return this.post<ICreateStripeConnectResponse>(
      `/hotels/${hotelId}/payments/connect/refresh`,
      payload,
    );
  }

  createStripeConnectLoginLink(
    hotelId: string,
  ): Promise<ICreateStripeConnectLoginLinkResponse> {
    return this.post<ICreateStripeConnectLoginLinkResponse>(
      `/hotels/${hotelId}/payments/connect/login-link`,
    );
  }

  getStripeConnectOnboardingStatus(
    hotelId: string,
  ): Promise<StripeAccountRequirementsState> {
    return this.get<StripeAccountRequirementsState>(
      `/hotels/${hotelId}/payments/connect/status`,
    );
  }

  syncStripeAccountStatus(
    hotelId: string,
  ): Promise<StripeAccountRequirementsState> {
    return this.post<StripeAccountRequirementsState>(
      `/hotels/${hotelId}/payments/connect/sync`,
    );
  }

  getHotelPaymentSettings(
    hotelId: string,
  ): Promise<IUpdateHotelPaymentSettingsPayload> {
    return this.get<IUpdateHotelPaymentSettingsPayload>(
      `/hotels/${hotelId}/payments/settings`,
    );
  }

  updateHotelPaymentSettings(
    hotelId: string,
    payload: IUpdateHotelPaymentSettingsPayload,
  ): Promise<void> {
    return this.patch<void>(`/hotels/${hotelId}/payments/settings`, payload);
  }

  getHotelPaymentMethods(
    hotelId: string,
  ): Promise<HotelPaymentMethodsResponse> {
    return this.get<HotelPaymentMethodsResponse>(
      `/hotels/${hotelId}/payments/methods`,
    );
  }

  updateHotelPaymentMethod(
    hotelId: string,
    payload: UpdateHotelPaymentMethodPayload,
  ): Promise<UpdateHotelPaymentMethodResponse> {
    return this.patch<UpdateHotelPaymentMethodResponse>(
      `/hotels/${hotelId}/payments/methods`,
      payload,
    );
  }
}

export const billingSettingsService = new BillingSettingsService();
